import "../../styles/routes/contractsPage.css";

function ContractsPage() {



    const mockContractsData = {
        data:
            [
                { link: "https://drive.google.com/file/d/1-Bf1o23WyZlDNY134q5hGQhpowEaNP_9/view?usp=sharing", nome: "Alteração de Planos e/ou Combos" },
                { link: "https://drive.google.com/file/d/1-KQLlwoMVGbmoXjbLQ-7m5uZqPSLYYvG/view?usp=sharing", nome: "Contrato de Prestação de Serviço de Valor Adicionado" },
                { link: "https://drive.google.com/file/d/1-E_k8urFQ9ueB66cgp8_OcyhsCsrxQjq/view?usp=sharing", nome: "Contrato de Comércio de Obras Digitais" },
                { link: "https://drive.google.com/file/d/1-B5aeDk0M-VuA-qH1azDXyNzxwl-zSWa/view?usp=sharing", nome: "Contrato de Prestação de Serviço de Comunicação Multimídia", }

            ],

    }

    return (
        <section>
            <h2 className="Contracts__title">Contratos</h2>
            <div className="contractsContainer">
                <div className="contractsList">
                    {
                        mockContractsData.data.map((contract, index) => (
                            <a
                                target="_blank"
                                rel="noreferrer"
                                key={index}
                                href={contract.link}
                                className="contractButton"
                            >
                                {contract.nome}
                            </a>
                        ))
                    }
                </div>


            </div>
        </section>
    );
}

export default ContractsPage;
